<<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" />
    <pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights">
     <li title='转人事考勤'  :class='selIdx!=undefined? "nav-system":"nav-system disabled"'>
        <a href="javascript:" @click='UpdateWeixinRights'>转人事考勤</a>
      </li>
      </pager-panel>
    <list-panel :config="config" :isAutoLoad='1' :rs="rs" @updateIdx="updateIdx" :selIdx="selIdx" />
</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin";

export default {

  created: function() {
    const dt = this.$dateNow();
    //alert(dt);
   // this.config.params.filingTimeF.data = dt;
this.config.params.filingTimeT.data = dt;
    //alert(this.config.dept);
    if (this.config.dept) {
      this.config.dept.forEach(d => {
        this.config.params.dept.options.push({
          value: d.deptNo,
          text: d.deptName
        });
      });
    }
  },

  data() {
    return {
      config: data
    };
  },
  

  methods: {
    UpdateWeixinRights() {
      const arr = this.getSelRow();
      //alert(arr.length);
      if (arr.length <= 0) this.alertRS("selFist");
      else {
        /* alert("1"+ this.config.url);
        alert("2"+this.$urlSq());
        alert("3"+arr); */
        this.$postData(
          this.config.url + "UpdateWeixinRights?" + this.$urlSq(),arr,
          data => {
            if (data && data.rs == 1) {
              this.$alert("更新成功！");
              this.$loadData(this.config);
            } else this.$alert("更新失败！");
          }
        );
      }
    }
    
  },
  mixins: [mixin.list],
};
</script>
